"use strict";jQuery.isCached=function(){if(!arguments.length)return!1;let e=new Image;return e.src=arguments[0],e.complete||e.width+e.height>0};